import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';

import BackgroundImage from '../../../../components/BackgroundImage';
import Img from '../../../../components/Img';
import { getNameInitials } from '../../../../utils/collegeCorner';

import { defaultGenderColumn, defaultRankingColumn, defaultTableFilters, defaultUtrDoublesColumn, defaultUtrDoublesMaskedColumn, defaultUtrSinglesColumn, defaultUtrSinglesMaskedColumn, doublesUtrMaskedRating, doublesUtrRating, doublesUtrTitle, singlesUtrMaskedRating, singlesUtrRating, singlesUtrTitle, SORT_ORDER } from '../helpers';
import styles from './CollegeCornerJuniorProspects.scss';

export const initialTableFilters = {
    ...defaultTableFilters,
    sort: 'singlesUtr',
};

export const initialFilters = {
    ...initialTableFilters,
    gender: null,
    locationInputValue: '',
    locationCountryName: '',
    locationStateName: '',
    distance: '',
    location: '',
    lat: null,
    lng: null,
    nationality: '',
    sportTypes: { tennis: true },
    utrMin: null,
    utrMax: null,
    utrType: 'verified',
    utrTeamType: 'singles',
    utrReliability: { rated: true },
    hsGradYears: '',
};

export const columns = [
    {
        ...defaultRankingColumn,
        maxWidth: 5,
        sortable: false,
        headerClassName: `${styles.rankingHead}`,
        rowClassName: `${styles.rankingCol}`,
        custom: (val, item, { rowIndex, total, order }) => {
            return order === SORT_ORDER.DESC ? rowIndex + 1 : total - rowIndex;
        },
    },
    {
        title: 'Player',
        sortable: false,
        key: 'lastName',
        maxWidth: 25,
        rowClassName: `${styles.playerCol}`,
        custom: (val, item) => {
            const nationalFlag = item?.source?.nationality
                ? `/img/flags/${item.source.nationality.toLowerCase()}.svg`
                : '';
            const playerName = item?.source?.displayName || '';
            return (
                <div className={`${styles.CollegeName}`}>
                    <div className={`${styles.displayLogo}`}>
                        {item?.source?.playerProfileImages?.default ? (
                                <BackgroundImage
                                    baseUrl={'/v1/player/'}
                                    defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                    images={item.source.playerProfileImages}
                                    imageType={'icon'}
                                    parentStylesClass={styles.profilePicture}
                                />
                        ) : (
                            <div className="avatar-placeholder border-grad-rad">
                                {getNameInitials(item.source)}
                            </div>
                        )}
                    </div>
                    <Link className="link" to={`/profiles/${item.id}`} data-testid={`college-corner.junior-prospects.player-${item.id}.profile-link`}>
                        {playerName}
                    </Link>
                    <div className={`${styles.nationalFlag}`}>
                        <Img
                            className="flag"
                            src={nationalFlag}
                            alt={item?.source?.nationality || ''}
                        />
                    </div>
                </div>
            );
        },
    },
    {
        ...defaultGenderColumn,
        maxWidth: 10,
        headerClassName: `${styles.genHead}`,
        rowClassName: `${styles.genCol}`,
        custom: (val, item) => item?.source?.gender || '',
    },
    {
        ...defaultUtrSinglesColumn,
        rowClassName: `${styles.utrCol}`,
        headerClassName: `${styles.utrHead}`,
        maxWidth: 10,
        title: singlesUtrTitle(styles),
        custom: (val, item) => singlesUtrRating(val, item, styles),
    },
    {
        ...defaultUtrSinglesMaskedColumn,
        rowClassName: `${styles.utrCol}`,
        headerClassName: `${styles.utrHead}`,
        maxWidth: 10,
        title: singlesUtrTitle(styles),
        custom: (val, item) => singlesUtrMaskedRating(val, item, styles),
    },
    {
        ...defaultUtrDoublesColumn,
        maxWidth: 12,
        rowClassName: `${styles.utrTwoCol}`,
        headerClassName: `${styles.utrTwoHead}`,
        title: doublesUtrTitle(styles),
        custom: (val, item) => doublesUtrRating(val, item, styles),
    },
    {
        ...defaultUtrDoublesMaskedColumn,
        maxWidth: 12,
        rowClassName: `${styles.utrTwoCol}`,
        headerClassName: `${styles.utrTwoHead}`,
        title: doublesUtrTitle(styles),
        custom: (val, item) => doublesUtrMaskedRating(val, item, styles),
    },
    {
        title: 'Grad Year',
        maxWidth: 11,
        sortable: false,
        headerClassName: `${styles.gradYearHead}`,
        rowClassName: `${styles.gradYearCol}`,
        custom: (val, item) => {
            const gradYearDetails =
                item?.source?.playerHighSchoolDetails?.gradYear &&
                item.source.playerHighSchoolDetails.gradYear;
            return gradYearDetails ? moment(gradYearDetails).format('YYYY') : '';
        },
    },
    {
        title: 'High School Team',
        maxWidth: 19,
        sortable: false,
        headerClassName: `${styles.schTeamHead}`,
        rowClassName: `${styles.schTeamCol}`,
        custom: (val, item) => {
            const playerSchoolDetails =
                item?.source?.playerHighSchool?.id && item.source.playerHighSchool;
            const gender = item?.source?.gender && item.source.gender;
            const collegeName = playerSchoolDetails?.name || '';
            const gradYearDetails = item?.source?.playerHighSchoolDetails?.gradYear && item.source.playerHighSchoolDetails.gradYear;
            return (
                collegeName && (
                    <div className={`${styles.CollegeName}`}>
                        <div className={`${styles.detail}`}>
                            <Link
                                className="link"
                                to={`/colleges/${(gender === 'Male' &&
                                    playerSchoolDetails?.mensClubId) ||
                                    ''}${(gender === 'Female' &&
                                        playerSchoolDetails?.womensClubId) ||
                                    ''}`}
                                data-testid={`college-corner.junior-prospects.player-${item.id}.school-link`}
                            >
                                {collegeName}
                            </Link>
                            <div className={`${styles.gYear}`}>
                                {gradYearDetails ? moment(gradYearDetails).format('YYYY') : ''}
                            </div>
                        </div>
                    </div>
                )
            );
        },
    },
    {
        title: 'Location',
        maxWidth: 15,
        sortable: false,
        headerClassName: `${styles.locHead}`,
        rowClassName: `${styles.locCol}`,
        custom: (val, item) => item?.source?.location?.display || '',
    },
];
